import BaseAuthProvider from './BaseAuthProvider'
import AuthService from '../service'
import { AuthProviders } from '../constants/authProviders'

/**
 * IBI Authentication Provider
 * Special integration for IBI (Italian Banking Institute)
 * Converts IBI tokens to application tokens
 */
export class IbiAuthProvider extends BaseAuthProvider {
    getMethod() {
        return AuthProviders.IBI
    }

    /**
     * IBI is controlled only by .env
     * Only enabled for specific IBI-related subdomains/integrations
     */
    isEnabled(context) {
        return context.envProviders.includes(this.getMethod())
    }

    /**
     * Authenticate with IBI token
     * @param {Object} credentials - IBI-specific credentials payload
     * @param {string} credentials.token - IBI OAuth token
     * @returns {Promise<{token: string, tokenType: string}>}
     */
    async authenticate(credentials) {
        if (!credentials.token) {
            throw new Error('IBI authentication requires token')
        }

        const response = await AuthService.convertIbiAuthToken(credentials)

        return {
            token: response.data.access_token,
            tokenType: 'Bearer'
        }
    }

    /**
     * No alternatives for IBI
     * It's a specialized integration
     */
    getAlternatives(enabledProviders) {
        return []
    }
}

export default IbiAuthProvider
